import React, { useContext, useEffect, useRef, useState } from "react";
import { createContactsV2, createPeople, crmBulkSearch, revealContact } from "../../../apis/ext";
import { useMutation, useQueryClient } from "react-query";
import { Skeleton } from "../../ui/skeleton";
import SingleContactCard from "../../ext/SingleContactCard";
import SharedDataContext from "../../../SharedDataContext";
import Header from "../../ext/Header";
import Image from "../../Tags/Image";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../ui/dropdown-menu";
import { Button } from "../../ui/button";
import { CheckIcon, ChevronDownIcon, Eye, EyeOffIcon, Trash2Icon } from "lucide-react";

import { useSearchPeopleByIds } from "../../ext/useSearchPeopleByIds";
import { useStoreBulkReveal } from "../../../stores/useStoreBulkReveal";
import { isMoreThanDaysOld } from "../../../cf";
import { useStoreIntegrations } from "../../../stores/useStoreIntegrations";

import toast from "react-hot-toast";
import { Badge } from "../../ui/badge";
import { useStoreCRMSearch } from "../../../stores/useStoreCRMSearch";
import { useStoreCRMConfig } from "../../../stores/useStoreCRMConfig";
import { useCRMSearchRecords } from "../../../apiHooks/useCRMSearchRecords";
import TooltipWrapper from "../../TooltipWrapper";
import { useStoreCRMAnalyse } from "../../../stores/useStoreCRMAnalyse";
import { useCRMAnalyseRecords } from "../../../apiHooks/useCRMAnalyseRecords";
import { useCsvUploader } from "../../../hooks/useCsvUploader";
import { DropdownMenuItemIndicator } from "@radix-ui/react-dropdown-menu";
import { useCaptureEvent } from "../../../hooks/useCaptureEvent";

const LOCAL_STORAGE_KEY = "persistedIds";

export default function BulkProfile() {
  const { userData, params } = useContext(SharedDataContext);
  const { activeWorkspace } = userData || {};
  const captureEvent = useCaptureEvent();

  const [profilesData, setProfilesData] = useState([]);
  const [profilesDataWithoutCompanyName, setProfilesDataWithoutCompanyName] = useState([]);
  const [people, setPeople] = useState([]);

  const [isBulkRevealed, setIsBulkRevealed] = useState(false);
  const [checkedItems, setCheckedItems] = useState([]);
  const [peopleIds, setPeopleIds] = useState(() => {
    const stored = sessionStorage.getItem(LOCAL_STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  });
  const [showCreatedContactsAlert, setShowCreatedContactsAlert] = useState(true);
  const [createdContacts, setCreatedContacts] = useState([]);
  const [showPreviousSelectedProfiles, setShowPreviousSelectedProfiles] = useState(false);

  const { contactIds, removeContactIdsByKey } = useStoreBulkReveal();

  // run once contact enriched
  const runAfterPeopleCreated = (_data = {}, uniqueProfiles = false) => {
    let data = _data;
    setPeople(data.records);
    data.records.forEach((item) => {
      let person = {};
      person = item.person;
      person.person_id = item?.person?.id;
      if (item.person && item.person.contacts && item.person.contacts.length === 0) {
        person.enrichment_lists = [];
      }
      if (item.person && item.person.contacts && item.person.contacts.length > 0) {
        person.contact_id = item.person.contacts[0]?.id;
        person.enrichment_lists = item.person.contacts[0].enrichment_lists;
        // addContactId({
        //   id: item.person.contacts[0]?.id,
        //   enrichment_lists: item.person.contacts[0].enrichment_lists
        //     ? item.person.contacts[0].enrichment_lists
        //     : [],
        // });
      }
    });
  };

  const createPeopleFn = useMutation("create_people", createPeople, {
    onSuccess(data, variables, context) {
      console.log("create_people data", data);

      if (data && data.records && data.records.length > 0) {
        runAfterPeopleCreated(data);
      }
      if (window && typeof window !== "undefined") {
        window.parent.postMessage("BULK_CONTACTPOST_ONSUCCESS", "*");
      }
    },
    onError(error) {
      console.log(error);
    },
  });

  const HandleCreatePeople = () => {
    if (createPeopleFn.isLoading) {
      return;
    }
    let payload = profilesData;

    if (payload && payload.length === 0) {
      return;
    }
    let payloadV2 = [];

    if (payload && payload.length > 0) {
      payload.forEach((el) => {
        let linkedin_ids = [];
        linkedin_ids.push(el.linkedin_profile_id);
        let obj = { ...el };

        const clean = (str) => !str || str.replace(/[\u200B-\u200F\uFEFF]/g, "").trim() === "";

        const isEmptyLast = clean(obj.last_name) && clean(obj.full_name);
        // const isEmptyLast =
        // obj.last_name == null || obj.last_name.replace(/[\u200B-\u200F\uFEFF]/g, "").trim() === "";

        // if (isEmptyLast) {
        //   if (obj.first_name != null && String(obj.first_name).trim() !== "") {
        //     obj.full_name = obj.first_name;
        //   }
        //   delete obj.first_name;
        //   delete obj.last_name;
        // }
        obj.linkedin_ids = linkedin_ids;
        obj.company_linkedin_url = el?.work_experience?.[0]?.company_linkedin_url
          ? el?.work_experience?.[0]?.company_linkedin_url
          : "";
        if (!isEmptyLast) {
          payloadV2.push(obj);
        }
      });
    }
    createPeopleFn.mutate({
      data: {
        records: [...payloadV2],
      },
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };

  const [revealedContacts, setRevealedContacts] = useState([]);

  const createContactsV2andRevealContacts = useMutation("enrich_profile_2", createContactsV2, {
    onSuccess(data, variables, context) {
      console.log("createContactsV2Fn", data);
      setRevealedContacts();
      // toast.success(data?.message);
      if (data && data?.data && data?.data?.contacts && data?.data?.contacts.length > 0) {
        let arr = data?.data?.contacts.map((el) => el.contact_id);
        // console.log("createContactsV2Fn arr", arr);
        // console.log("createContactsV2Fn(contactIds)", getCheckedRecentContacts(contactIds));
        const filteredArr = arr.filter(
          (id) => !getCheckedRecentContacts(contactIds).some((contact) => contact.id === id)
        );
        console.log("filteredArr", filteredArr);
        handleRevealContact(filteredArr);
        const result = data?.data?.contacts.map(({ person_id, contact_id }) => ({
          person_id,
          contact_id,
        }));
        setRevealedContacts(result);
      }
    },
    onError(error) {
      console.log(error);
      // Close the pre-opened window if the enrich API fails (e.g. insufficient credits)
      if (pendingWindowRef.current && !pendingWindowRef.current.closed) {
        pendingWindowRef.current.close();
        pendingWindowRef.current = null;
      }
    },
  });

  const handleCreateContactsV2andRevealContacts = (payload) => {
    console.log(payload);
    const payloadV2 = payload.map((item) => ({ person_id: item }));

    if (createContactsV2andRevealContacts.isLoading) {
      return;
    }
    createContactsV2andRevealContacts.mutate({
      data: {
        contacts: payloadV2,
      },
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };

  ////////////////////////////
  // create contacts

  const createContactsV2Fn = useMutation("enrich_profile", createContactsV2, {
    onSuccess(data, variables, context) {
      console.log("createContactsV2Fn", data);
      // toast.success(data?.message);
      if (data && data?.data && data?.data?.contacts && data?.data?.contacts.length > 0) {
        let arr = data?.data?.contacts.map((el) => el.contact_id);
        console.log("createContactsV2Fn arr", arr);
        setCreatedContacts(arr);
      }
    },
    onError(error) {
      console.log(error);
    },
  });

  const handleCreateContactsV2 = (payload) => {
    console.log(payload);
    const payloadV2 = payload.map((item) => ({ person_id: item }));

    if (createContactsV2Fn.isLoading) {
      return;
    }
    createContactsV2Fn.mutate({
      data: {
        contacts: payloadV2,
      },
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };

  const [enrichId, setEnrichedId] = useState("");
  const [currentPerson, setCurrentPerson] = useState({});
  const revealContactFn = useMutation("enrich_profile", revealContact, {
    onSuccess(data, variables, context) {
      console.log("enrich_profile enriched", data);
      setEnrichedId(data?.data?.id);
      setIsBulkRevealed(true);
    },
    onError(error) {
      console.log(error);
      // Close the pre-opened window if the enrich API fails (e.g. insufficient credits)
      if (pendingWindowRef.current && !pendingWindowRef.current.closed) {
        pendingWindowRef.current.close();
        pendingWindowRef.current = null;
      }
      // setIsBulkRevealed(true);
      // HandleCreatePeople();
    },
  });
  const handleRevealContact = (payload) => {
    let arr = [];
    payload.forEach((el) => {
      let obj = {};
      obj.contact_id = el;
      arr.push(obj);
    });

    const construct_payload = {
      settings: {
        verify: ["work_email", "mobile_phone", "personal_email"],
      },
      requirements: ["mobile_phone", "direct_phone", "work_email", "personal_email"],
      enrichment_type: "People",
      records: [...arr],
    };
    console.log("payload", construct_payload);
    revealContactFn.mutate({
      data: {
        ...construct_payload,
      },
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };
  useEffect(() => {
    console.log("profilesData", profilesData);
    if (profilesData?.length > 0 && activeWorkspace?.id) {
      HandleCreatePeople();
    }
  }, [profilesData, activeWorkspace?.id]);

  const setInitArrays = (data) => {
    const profile_data = JSON.parse(JSON.stringify(data));
    const finalProfilesData = profile_data.filter((el) => el.company_name);
    setProfilesData(finalProfilesData);
    setProfilesDataWithoutCompanyName(profile_data.filter((el) => el.company_name == "" && el.first_name));
  };
  useEffect(() => {
    // Let parent know iframe is ready
    window.parent.postMessage({ action: "IFRAME_READY" }, "*");
  }, []);
  useEffect(() => {
    const messageHandler = (event) => {
      console.log("event in bulk profile page action", event?.data?.action);
      console.log("event in bulk profile page data", event?.data?.data);
      if (!event.data?.action) return;

      if (event.data.action === "RECEIVE_PROFILES_DATA") {
        const profile_data = event.data.data;
        console.log("RECEIVE_PROFILES_DATA", profile_data);
        if (!Array.isArray(profile_data)) return; // guard against bad data

        localStorage.removeItem("profilesData");
        localStorage.setItem("profilesData", JSON.stringify(profile_data));
        setInitArrays(profile_data);

        event.source?.postMessage({ action: "DATA_RECEIVED" }, "*");
        console.log("✅ Data received and stored in iframe");
      }
    };

    window.addEventListener("message", messageHandler);
    return () => window.removeEventListener("message", messageHandler);
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      clearProfiles();
      const handleLoadBulkPage = () => {
        const savedData = localStorage.getItem("profilesData");
        if (savedData) {
          setInitArrays(JSON.parse(savedData));
        }
      };
      window.addEventListener("load_bulk_page", handleLoadBulkPage);
      return () => {
        window.removeEventListener("load_bulk_page", handleLoadBulkPage);
      };
    }
  }, []);

  ////////////////////////////

  const getProfileObj = (linkedin_profile_id) => {
    if (profilesData && profilesData.length > 0) {
      return profilesData.find((profile) => profile.linkedin_profile_id === linkedin_profile_id);
    }
  };

  const toggleCheckbox = (person) => {
    setCheckedItems((prev) => {
      const exists = prev.some((item) => item.id === person.id);

      if (exists) {
        return prev.filter((item) => item.id !== person.id);
      } else {
        return [...prev, person];
      }
    });
  };

  // Save to sessionStorage when user toggles checkboxes
  useEffect(() => {
    if (peopleIds.length === 0) {
      setShowPreviousSelectedProfiles(false);
    }
    sessionStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(peopleIds));
  }, [peopleIds]);

  // 👇 This ref holds the original value (used only once)
  const initialIdArrayRef = useRef(peopleIds);

  // Ref to hold a pre-opened window to avoid popup blockers
  const pendingWindowRef = useRef(null);

  const togglePeopleId = (id) => {
    setPeopleIds((prev) => (prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]));
  };
  const removePeopleIds = (idsToRemove) => {
    setPeopleIds((prev) => prev.filter((id) => !idsToRemove.includes(id)));
  };

  const {
    people: peopleFromIds,
    isLoading,
    error,
    refetch: refetchProfiles,
    clearProfiles,
  } = useSearchPeopleByIds(initialIdArrayRef?.current, activeWorkspace?.id);

  const getCurrentPageCheckedProfiles = () => {
    let filteredContacts = [];
    if (people && people.length > 0) {
      filteredContacts = people.filter((item) => peopleIds.includes(item?.person?.id));
    }

    return filteredContacts;
  };

  const isThisProfileInCurrentEnrichedContacts = (id) => {
    if (people && people.length > 0) {
      let obj = people.find((item) => item?.person?.id === id);

      if (obj?.person?.id) {
        return true;
      }
    } else {
      return false;
    }
  };

  const togglePreviousSelectedProfiles = () => {
    setShowPreviousSelectedProfiles(!showPreviousSelectedProfiles);
  };

  const getCheckedRecentContacts = (contacts = [], days = 7) => {
    return contacts.filter((contact) => {
      if (!contact.checked) return false;

      const enrichmentLists = contact.enrichment_lists;
      if (!enrichmentLists || enrichmentLists.length === 0) return false;

      const latestCreatedAt = enrichmentLists[enrichmentLists.length - 1].created_at;

      return !isMoreThanDaysOld(latestCreatedAt, days); // ✅ NOT more than `days` old
    });
  };

  const {
    savedCRMConfig: crmObjectsConfig,
    savedCompanyConfig,
    savedCompanyConfigObj,
    savedPeopleConfig: personArr,
    savedCompanyConfigWithWritePermission,
    savedPeopleConfigWithWritePermission,
  } = useStoreCRMConfig();

  const queryClient = useQueryClient();
  const [activeCrmId, setActiveCrmId] = useState("");
  const { installedCRMIntegrations, activeCRMIntegration, activeDataProviderIntegrations } =
    useStoreIntegrations();
  useEffect(() => {
    setActiveCrmId(activeCRMIntegration?.id);
  }, [activeCRMIntegration]);

  // analyse
  const {
    setCRMBulkAnalysePayload,
    isCRMBulkAnalyseLoading,
    getCRMAnalyseRecordById,
    crmBulkAnalyseData,
    isCRMBulkAnalyseFetched,
  } = useStoreCRMAnalyse();

  const { mutate: handleCRMAnalyse, isLoading: isCRMAnalyseLoading } = useCRMAnalyseRecords();

  // crm bulk search

  const {
    setCRMBulkSearchPayload,
    isCRMBulkSearchLoading,
    getCRMSearchRecordById,
    crmBulkSearchData,
    isCRMBulkSearchFetched,
    getCRMSearchRecordByIdFlat,
  } = useStoreCRMSearch();

  const { mutate: handleCRMSearch, isLoading: isCRMSearchLoading } = useCRMSearchRecords();

  const handleCRMBulkSearch = (crmBulkSearchPayload = [], crmConfigId) => {
    if (crmBulkSearchPayload?.length === 0 || isCRMSearchLoading) {
      return;
    }
    console.log("handleCRMBulkSearch", { crmBulkSearchPayload, crmConfigId });
    handleCRMSearch({
      data: crmBulkSearchPayload,
      configId: crmConfigId,
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };

  useEffect(() => {
    if (activeCRMIntegration && activeCRMIntegration.id && !isLoading && createPeopleFn.isSuccess) {
      console.log("people", people);
      const cleanPeople = people.map((item) => item.person);
      console.log("cleanPeople", cleanPeople);

      const uniquePeopleMap = new Map();

      [...cleanPeople, ...peopleFromIds].forEach((person) => {
        uniquePeopleMap.set(person.id, person); // Later entries will overwrite earlier ones
      });

      const allPeople = Array.from(uniquePeopleMap.values());

      // const allPeople = [...cleanPeople, ...peopleFromIds];
      console.log("allPeople", allPeople);
      // const payload = allPeople.map((item) => ({
      //   person_id: item?.id,
      //   reference_organization_id: item?.current_company?.organization_ids?.system,
      //   type: "person",
      //   edit_search: false,
      // }));

      const payload = allPeople.map((item) => {
        const base = {
          person_id: item?.id,
          reference_organization_id: item?.current_company?.organization_ids?.system,
          type: "person",
          edit_search: false,
        };

        if (item?.contact_id) {
          base.contact_id = item.contact_id;
        }

        return base;
      });
      setCRMBulkSearchPayload(payload);
      console.log("payload", payload);
      handleCRMBulkSearch(payload, activeCRMIntegration.id);
    }
  }, [
    activeCRMIntegration && activeCRMIntegration.id,
    people.length,
    peopleFromIds.length,
    isLoading,
    createPeopleFn.isSuccess,
  ]);

  const cleanName = (name) => {
    if (name) {
      const cleaned = name.replace(/[^\x00-\xFF]/g, "");
      return cleaned;
    } else {
      return "";
    }
  };

  console.log("crmBulkSearchData", crmBulkSearchData);

  function buildCsvPayload(people, peopleFromIds, peopleIds) {
    // Step 1: extract clean people from the `people` array
    const cleanPeople = people.map((item) => item.person);

    // Step 2: create a map to ensure uniqueness by `id`
    const uniquePeopleMap = new Map();

    [...cleanPeople, ...peopleFromIds].forEach((person) => {
      if (person?.id) {
        uniquePeopleMap.set(person.id, person); // later entry overwrites earlier
      }
    });

    // Step 3: final unique people array
    const allPeople = Array.from(uniquePeopleMap.values());
    const filteredPeople = allPeople.filter((item) => peopleIds.includes(item?.id));

    // Step 4: build CSV payload
    const csvPayload = filteredPeople.map((item) => ({
      linkedin_url: item?.linkedin_url || "",
      first_name: item?.name?.first || "",
      last_name: item?.name?.last || "",
      full_name: item?.name?.full || "",
      designation: item?.current_job_title || "",
      company_name: item?.current_company?.name || "",
    }));

    return csvPayload;
  }

  const handleCRMBulkAnalyse = (crmBulkAnalysePayload = [], crmConfigId) => {
    if (crmBulkAnalysePayload?.length === 0) {
      return;
    }
    console.log("handleCRMBulkAnalyse", { crmBulkAnalysePayload, crmConfigId });
    handleCRMAnalyse({
      data: crmBulkAnalysePayload,
      configId: crmConfigId,
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };

  useEffect(() => {
    if (isCRMBulkSearchFetched) {
      console.log("crmBulkSearchData fetched", crmBulkSearchData);
      let analysePayload = [];
      if (
        crmBulkSearchData &&
        crmBulkSearchData.length > 0 &&
        activeCRMIntegration &&
        activeCRMIntegration.id
      ) {
        crmBulkSearchData.forEach((el) => {
          const crmRecords = getCRMSearchRecordByIdFlat(el?.contact_id || el?.person_id);
          const matchedObj =
            crmRecords && crmRecords.length > 0 && crmRecords.find((el) => el.match_confirmed);
          let obj = {
            type: "person",
          };
          if (el.contact_id) {
            obj.contact_id = el.contact_id;
          }
          if (el.person_id) {
            obj.person_id = el.person_id;
          }
          if (matchedObj && matchedObj.Id) {
            obj.crm_record_id = matchedObj.Id;
            analysePayload.push(obj);
          }
        });
        console.log("analysePayload", analysePayload);
        setCRMBulkAnalysePayload(analysePayload);
        if (activeCRMIntegration && activeCRMIntegration.id) {
          handleCRMBulkAnalyse(analysePayload, activeCRMIntegration.id);
        }
      }
    }
  }, [crmBulkSearchData, isCRMBulkSearchFetched, activeCRMIntegration]);

  console.log("crmBulkAnalyseData", crmBulkAnalyseData);

  const openBulkPushPage = (person, enrichId = "") => {
    if (peopleIds.length === 0) {
      toast.error("Please select contacts");
      return;
    }

    const cleanPeople = people.map((item) => item.person);

    const uniquePeopleMap = new Map();

    [...cleanPeople, ...peopleFromIds].forEach((person) => {
      uniquePeopleMap.set(person.id, person); // Later entries will overwrite earlier ones
    });

    const allPeople = Array.from(uniquePeopleMap.values());

    const peopleList = [];
    allPeople.forEach((el2) => {
      if (peopleIds.includes(el2.id)) {
        const isRevealedObj =
          contactIds && contactIds.length > 0 && contactIds.find((c) => c.person_id === el2.id);
        let obj = {
          person_id: el2.id,
          orgSystemId: el2?.current_company?.organization_ids?.system,
          orgLinkedInUrl: el2?.current_company?.linkedin_url,
          orgName: cleanName(el2?.current_company?.name),
          isRevealed:
            isRevealedObj && isRevealedObj.enrichment_lists && isRevealedObj.enrichment_lists.length > 0
              ? true
              : false,
        };
        if (el2?.contact_id) {
          obj.contact_id = el2.contact_id;
        }
        peopleList.push(obj);
      }
    });

    console.log("peopleList Test", peopleList);
    let payloadPeopleList = peopleList;

    if (revealedContacts && revealedContacts.length > 0) {
      payloadPeopleList = peopleList.map((item) => {
        const match = revealedContacts.find((res) => res.person_id === item.person_id);
        if (match) {
          return {
            ...item,
            contact_id: match.contact_id,
            isRevealed: true,
          };
        }
        return item;
      });
    }

    const queryObject = {
      crm_object_api_name: person.crm_object_api_name,
      crm_object_api_name_company: savedCompanyConfigObj?.crm_object_api_name,
      crm_object_label_company: savedCompanyConfigObj?.crm_object_label,
      contacts: payloadPeopleList,
      callbackUrl: "https://www.linkedin.com/company/lambdatest?tab=contacts",
    };

    const uniqueKey = `push_to_crm_payload_${Date.now()}`;
    const targetUrl = `/${process.env.REACT_APP_APP_HOME}/${activeWorkspace?.slug}/company-contact-list/push-to-crm?payload=${uniqueKey}&enrichId=${enrichId}`;

    // Use pre-opened window if available (to avoid popup blockers), otherwise open new
    let win = pendingWindowRef.current;
    if (win && !win.closed) {
      win.location = targetUrl;
      pendingWindowRef.current = null;
    } else {
      win = window.open(targetUrl);
    }

    window.addEventListener("message", function handshakeListener(event) {
      if (event.data === "ready_for_payload") {
        win.postMessage({ payloadKey: uniqueKey, payload: queryObject });
        window.removeEventListener("message", handshakeListener);
      }
    });
    setPeopleIds([]);
  };
  const getLatestEnrichmentListId = (contacts = []) => {
    const checkedContacts = contacts.filter((c) => c.checked);

    const latest = checkedContacts
      .map((contact) => {
        const lists = contact.enrichment_lists || [];

        if (lists.length === 0) return null;

        const latestList = lists.reduce((a, b) => (new Date(a.created_at) > new Date(b.created_at) ? a : b));

        return latestList.id;
      })
      .filter(Boolean); // removes nulls

    return latest.length > 0 ? latest[0] : null;
  };

  useEffect(() => {
    if (currentPerson && currentPerson?.id && enrichId) {
      openBulkPushPage(currentPerson, enrichId);
      setEnrichedId("");
      setCurrentPerson({});
    }
  }, [currentPerson, enrichId, revealedContacts]);

  const buildProfileName = (profile = {}) => {
    let nameObj = {
      first: "",
      last: "",
      middle: "",
      full: "",
    };

    // Case 1: if explicit first_name + last_name exist
    if (profile.first_name && profile.last_name) {
      nameObj = {
        first: profile.first_name.trim(),
        last: profile.last_name.trim(),
        full: `${profile.first_name.trim()} ${profile.last_name.trim()}`,
        middle: "",
      };
      return nameObj;
    }

    // Case 2: only full_name provided
    if (profile.full_name) {
      const parts = profile.full_name
        .split(/\s+/) // split on spaces
        .filter(Boolean); // remove empties

      if (parts.length === 1) {
        // only one word
        nameObj = {
          first: "",
          last: "",
          middle: "",
          full: parts[0],
        };
      } else if (parts.length === 2) {
        // two words
        nameObj = {
          first: parts[0],
          last: parts[1],
          middle: "",
          full: profile.full_name.trim(),
        };
      } else {
        // more than 2 words
        nameObj = {
          first: parts[0],
          last: parts[parts.length - 1],
          middle: parts.slice(1, -1).join(" "),
          full: profile.full_name.trim(),
        };
      }
    }

    return nameObj;
  };

  const { uploadCsv, isCSVUploadLoading } = useCsvUploader(activeWorkspace, userData?.name);
  const [clickedExportCsv, setClickedExportCsv] = useState(false);
  const [enrichmentMode, setEnrichmentMode] = useState("Phone");
  const enrichmentModes = [
    {
      name: "Phone",
      value: "Phone",
      icon: "type_Phone.svg",
    },
    {
      name: "Email",
      value: "Email",
      icon: "type_Email_new.png",
    },
    {
      name: "Email and Phone",
      value: "Email and Phone",
      icon: "type_phoneEmail.png",
    },
    {
      name: "Email or Phone",
      value: "Email or Phone",
      icon: "type_any.png",
    },
  ];
  return (
    <div className="relative">
      <Header homeLink="/contact-viewer/bulk-profiles" />
      <div className="space-y-3 p-3 pb-[85px]">
        {profilesData &&
          profilesData.length === 0 &&
          profilesDataWithoutCompanyName &&
          profilesDataWithoutCompanyName.length === 0 &&
          [1, 2, 3, 4, 5, 6].map((i) => (
            <div className="py-4 pt-3.5 px-5 items-center border border-input  bg-background rounded-[14px] relative overflow-hidden">
              <div className="flex items-center space-x-3">
                <span className="h-10 w-10 rounded-full bg-slate-300"></span>
                <div>
                  <Skeleton className="h-[20px] w-[200px]" />
                  <span className="text-[12px] text-gray-900 flex items-center space-x-2 mt-0.5">
                    <Skeleton className="h-[15px] w-[70px] inline-flex" />
                    <Skeleton className="h-[15px] w-[70px] inline-flex" />
                  </span>
                </div>
              </div>
              <div className="mt-3">
                <Skeleton className="h-[40px] w-[150px]" />
              </div>
            </div>
          ))}

        {userData &&
          userData.id &&
          profilesData &&
          profilesData.length > 0 &&
          !createPeopleFn.isLoading &&
          people.length > 0 && (
            // personArr &&
            // personArr.length > 0 &&
            <>
              {/* {createdContacts &&
                createdContacts.length > 0 &&
                createContactsV2Fn.isSuccess &&
                showCreatedContactsAlert && (
                  <div className="border p-3 rounded-xl bg-background flex justify-between">
                    <div className="inline-flex items-center space-x-2">
                      <span className="inline-flex rounded-xl border p-2 items-center justify-center mr-2">
                        <Image src="/favicon.png" width={22} height={22} className="no-invert " />
                      </span>
                      <div>
                        <div className="font-bold text-gray-800">
                          {createdContacts?.length} contacts added successfully
                        </div>
                        <a
                          // href={`${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_APP_HOME}/${activeWorkspace.slug}/contacts?contacts=${btoa(createdContacts)}`}
                          href={`${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_APP_HOME}/${activeWorkspace.slug}/contacts?contacts=${btoa(createdContacts)}`}
                          className="text-brand-700 font-bold block mt-0.5"
                          target="_blank"
                        >
                          View in {process.env.REACT_APP_APP_NAME}
                        </a>
                      </div>
                    </div>
                    <Image
                      width="16"
                      height="16"
                      className="no-invert cursor-pointer ml-2"
                      src="/images/ext/close.svg"
                      onClick={() => {
                        setShowCreatedContactsAlert(false);
                      }}
                    />
                  </div>
                )} */}
              {peopleIds?.length > 100 && (
                <div className="bg-red-100 border-red-500 border text-red-700 p-3 rounded-lg">
                  You can process only 100 records at a time.
                </div>
              )}
              <div className="flex justify-between">
                <DropdownMenu
                  onOpenChange={(open) => {
                    if (!open) {
                      setClickedExportCsv(false);
                    }
                  }}
                >
                  <DropdownMenuTrigger
                    className="inline-flex focus:outline-none"
                    disabled={peopleIds?.length === 0 || createContactsV2Fn.isLoading ? true : false}
                  >
                    <Button
                      // variant="outline"
                      className={`inline-flex items-center text-xs h-8 ${peopleIds?.length === 0 && "opacity-70"}`}
                    >
                      {/* <Image
                      src="/images/logos/integrations/crm.svg"
                      width={24}
                      className="no-invert mr-2"
                    /> */}
                      <span>Export {peopleIds?.length > 0 && peopleIds?.length} contacts</span>
                      {createContactsV2Fn.isLoading && (
                        <div className="loader_circle inline-block ml-2"></div>
                      )}
                      <ChevronDownIcon className="ml-2" width={18} height={18} />
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuPortal>
                    <DropdownMenuContent className="w-[230px]" align="start">
                      {clickedExportCsv ? (
                        <>
                          <div className="flex w-full py-2.5 items-center">
                            <Image
                              src="/images/icons/untitledui/csv-icon.svg"
                              width={20}
                              className="no-invert mr-2.5 ml-2"
                            />
                            <span>Select enrichment mode</span>
                          </div>
                          <DropdownMenuSeparator />
                          {enrichmentModes.map((mode) => (
                            <DropdownMenuItem
                              value={mode?.value}
                              onSelect={(e) => {
                                e.preventDefault();
                                setEnrichmentMode(mode?.value);

                                // PostHog: Track enrichment mode selection
                                captureEvent("EXP_BulkProfile_ExportCSV_ModeSelect", {
                                  enrichment_mode: mode?.value,
                                });
                              }}
                              className="py-2 [&>[data-state=checked]]:hidden [&>[data-state=unchecked]]:hidden justify-between items-center px-3"
                            >
                              <span className="inline-flex items-center">
                                <Image
                                  src={`/images/icons/${mode?.icon}`}
                                  className="rounded no-invert mr-2.5"
                                  width={22}
                                  height={18}
                                />
                                <span>{mode?.name}</span>
                              </span>
                              {mode.value === enrichmentMode && (
                                <CheckIcon className="w-4 h-4 text-green-600" />
                              )}
                            </DropdownMenuItem>
                          ))}

                          <DropdownMenuSeparator />

                          <div className="flex justify-between space-x-1.5 px-2 py-2">
                            <Button
                              variant="outline"
                              className="flex-1 h-9"
                              onClick={() => {
                                setClickedExportCsv(false);
                              }}
                            >
                              Back
                            </Button>
                            <Button
                              className="flex w-full items-center justify-center h-9 flex-1"
                              disabled={isCSVUploadLoading}
                              onClick={() => {
                                if (isCSVUploadLoading) {
                                  return;
                                }
                                setClickedExportCsv(false);
                                console.log("peopleFromIds", { peopleFromIds, people, peopleIds });
                                console.log("CSV_Payload", buildCsvPayload(people, peopleFromIds, peopleIds));

                                // PostHog: Track CSV export submit
                                captureEvent("EXP_BulkProfile_ExportCSV_SubmitClick", {
                                  contacts_count: peopleIds?.length,
                                  enrichment_mode: enrichmentMode,
                                });

                                uploadCsv(buildCsvPayload(people, peopleFromIds, peopleIds), enrichmentMode);
                              }}
                            >
                              <span>Submit</span>
                              {isCSVUploadLoading && <div className="loader_circle inline-block ml-2" />}
                            </Button>
                          </div>
                        </>
                      ) : (
                        <DropdownMenuGroup>
                          {/* <DropdownMenuItem
                            disabled={peopleIds?.length > 100}
                            onClick={() => {
                              // PostHog: Track add to app click
                              captureEvent("EXP_BulkProfile_AddToAppClick", {
                                contacts_count: peopleIds?.length,
                              });
                              handleCreateContactsV2(peopleIds);
                            }}
                          >
                            <div className="flex w-full py-1">
                              <Image src="/favicon.png" width={22} height={22} className="no-invert mr-2" />
                              <span>Add to {process.env.REACT_APP_APP_NAME}</span>
                            </div>
                          </DropdownMenuItem> */}
                          <DropdownMenuItem
                            onSelect={(e) => {
                              e.preventDefault(); // stop Radix from closing
                              setClickedExportCsv(true); // swap to radio menu
                            }}
                            // onClick={() => {
                            //   if (isCSVUploadLoading) {
                            //     return;
                            //   }
                            //   console.log("peopleFromIds", { peopleFromIds, people, peopleIds });
                            //   console.log("CSV_Payload", buildCsvPayload(people, peopleFromIds, peopleIds));
                            //   uploadCsv(buildCsvPayload(people, peopleFromIds, peopleIds));
                            // }}
                          >
                            <div className="flex w-full py-1 items-center">
                              <Image
                                src="/images/icons/untitledui/csv-icon.svg"
                                width={20}
                                className="no-invert mr-2.5"
                              />
                              <span>Enrich & export as CSV</span>
                              {isCSVUploadLoading && <div className="loader_circle inline-block ml-1"></div>}
                            </div>
                          </DropdownMenuItem>

                          {/* <DropdownMenuItem
                            disabled={peopleIds?.length > 100}
                            className={`${peopleIds?.length - getCheckedRecentContacts(contactIds).length === 0 && "opacity-50  pointer-events-none"}`}
                            onClick={() => {
                              if (activeDataProviderIntegrations?.length === 0) {
                                toast.error("You do not have any active Data provider integration.");
                              } else {
                                if (peopleIds?.length - getCheckedRecentContacts(contactIds).length === 0) {
                                  return;
                                }
                                if (
                                  createContactsV2andRevealContacts.isLoading ||
                                  revealContactFn.isLoading
                                ) {
                                  return;
                                }
                                handleCreateContactsV2andRevealContacts(peopleIds);
                              }
                            }}
                          >
                            <div className="flex w-full py-1">
                              <svg
                                width="20"
                                height="21"
                                viewBox="0 0 20 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="mr-2"
                              >
                                <path
                                  d="M6.98356 7.71098C7.56356 8.919 8.35422 10.0512 9.35553 11.0525C10.3568 12.0538 11.4891 12.8445 12.6971 13.4245C12.801 13.4744 12.8529 13.4993 12.9187 13.5185C13.1523 13.5866 13.4392 13.5377 13.637 13.396C13.6927 13.3561 13.7403 13.3085 13.8356 13.2132C14.1269 12.9219 14.2726 12.7762 14.4191 12.681C14.9715 12.3218 15.6837 12.3218 16.2361 12.681C16.3825 12.7762 16.5282 12.9219 16.8196 13.2132L16.9819 13.3756C17.4248 13.8185 17.6462 14.0399 17.7665 14.2777C18.0058 14.7507 18.0058 15.3093 17.7665 15.7822C17.6462 16.0201 17.4248 16.2415 16.9819 16.6844L16.8506 16.8157C16.4092 17.2571 16.1886 17.4777 15.8885 17.6463C15.5556 17.8333 15.0385 17.9678 14.6567 17.9666C14.3126 17.9656 14.0774 17.8989 13.607 17.7654C11.0792 17.0479 8.69387 15.6942 6.70388 13.7042C4.7139 11.7142 3.36017 9.32888 2.6427 6.80105C2.50919 6.33068 2.44244 6.0955 2.44141 5.75137C2.44028 5.36952 2.57475 4.85245 2.76176 4.51952C2.9303 4.2195 3.15098 3.99882 3.59233 3.55747L3.72369 3.42611C4.16656 2.98324 4.388 2.7618 4.62581 2.64152C5.09878 2.40229 5.65734 2.40229 6.1303 2.64152C6.36812 2.7618 6.58955 2.98324 7.03242 3.42611L7.19481 3.5885C7.48615 3.87984 7.63182 4.0255 7.72706 4.17199C8.08622 4.7244 8.08622 5.43655 7.72706 5.98896C7.63182 6.13544 7.48615 6.28111 7.19481 6.57244C7.09955 6.6677 7.05192 6.71533 7.01206 6.77101C6.87038 6.96887 6.82146 7.25575 6.88957 7.48938C6.90873 7.55512 6.93367 7.60708 6.98356 7.71098Z"
                                  stroke="var(--gray-500)"
                                  stroke-width="1.66667"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              <span>
                                Reveal all contacts
                                {peopleIds?.length > 0 && (
                                  <>
                                    {" "}
                                    (
                                    {peopleIds?.length - getCheckedRecentContacts(contactIds).length < 0
                                      ? 0
                                      : peopleIds?.length - getCheckedRecentContacts(contactIds).length}
                                    /{peopleIds?.length}){" "}
                                  </>
                                )}
                              </span>
                              {(revealContactFn.isLoading || createContactsV2andRevealContacts.isLoading) && (
                                <div className="loader_circle inline-block ml-1"></div>
                              )}
                            </div>
                          </DropdownMenuItem> */}

                          <DropdownMenuSeparator />

                          {personArr &&
                            personArr.length > 0 &&
                            personArr.map((person) => (
                              <TooltipWrapper
                                content={
                                  savedPeopleConfigWithWritePermission &&
                                  !savedPeopleConfigWithWritePermission.find(
                                    (el) => el.crm_object_api_name === person.crm_object_api_name
                                  ) &&
                                  `No permission to create`
                                }
                                className="w-full"
                              >
                                <DropdownMenuItem
                                  disabled={
                                    (savedPeopleConfigWithWritePermission &&
                                      !savedPeopleConfigWithWritePermission.find(
                                        (el) => el.crm_object_api_name === person.crm_object_api_name
                                      )) ||
                                    peopleIds?.length > 100
                                  }
                                  onClick={() => {
                                    // PostHog: Track push to CRM click
                                    captureEvent("EXP_BulkProfile_PushToCRM_Click", {
                                      contacts_count: peopleIds?.length,
                                      crm_object_label: person?.crm_object_label,
                                    });

                                    setCurrentPerson(person);
                                    console.log("contactIds", contactIds);
                                    if (
                                      peopleIds?.length - getCheckedRecentContacts(contactIds).length ===
                                      0
                                    ) {
                                      openBulkPushPage(person, getLatestEnrichmentListId(contactIds));
                                      return;
                                    }
                                    if (
                                      createContactsV2andRevealContacts.isLoading ||
                                      revealContactFn.isLoading
                                    ) {
                                      openBulkPushPage(person, getLatestEnrichmentListId(contactIds));
                                      return;
                                    }
                                    // Pre-open window in click handler to avoid popup blocker
                                    pendingWindowRef.current = window.open('about:blank', '_blank');
                                    // Show a loading screen matching the app's loading style
                                    try {
                                      pendingWindowRef.current.document.write(
                                        '<html><head><title>' + (process.env.REACT_APP_APP_NAME || 'PrimeRole') + '</title></head>' +
                                        '<body style="margin:0;font-family:Inter,-apple-system,BlinkMacSystemFont,sans-serif;">' +
                                        '<div style="display:flex;height:100vh;width:100%;justify-content:center;align-items:center;">' +
                                        '<div style="display:flex;justify-content:center;flex-direction:column;align-items:center;">' +
                                        '<div style="border:0.2em solid #7F56D9;border-left-color:#E9D7FE;font-size:18px;border-radius:50%;width:2em;height:2em;animation:spin 1.1s linear infinite;"></div>' +
                                        '<p style="font-size:16px;font-weight:600;color:#6b7280;margin-top:12px;">Preparing your records…</p>' +
                                        '</div></div>' +
                                        '<style>@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}</style>' +
                                        '</body></html>'
                                      );
                                      pendingWindowRef.current.document.close();
                                    } catch (e) { /* cross-origin — ignore */ }
                                    handleCreateContactsV2andRevealContacts(peopleIds);
                                  }}
                                >
                                  <div className="flex w-full py-1 items-center">
                                    <Image
                                      src={`/images/logos/integrations/${activeCRMIntegration?.integration?.key}.svg`}
                                      width={24}
                                      className="no-invert mr-2 h-4"
                                    />
                                    <span>Add to CRM</span>
                                    <Badge variant="gray" className="ml-3">
                                      {person?.crm_object_label}
                                    </Badge>
                                  </div>
                                </DropdownMenuItem>
                              </TooltipWrapper>
                            ))}
                        </DropdownMenuGroup>
                      )}
                    </DropdownMenuContent>
                  </DropdownMenuPortal>
                </DropdownMenu>
                {getCurrentPageCheckedProfiles().length < peopleIds.length && (
                  <span
                    className="inline-flex items-center text-brand-700 font-bold text-xs cursor-pointer"
                    onClick={() => {
                      // PostHog: Track show/hide previous selections
                      captureEvent("EXP_BulkProfile_ShowPreviousSelections", {
                        action: showPreviousSelectedProfiles ? "hide" : "show",
                      });
                      togglePreviousSelectedProfiles();
                    }}
                  >
                    {showPreviousSelectedProfiles ? <EyeOffIcon width={18} /> : <Eye width={18} />}

                    <span className="ml-2">
                      {showPreviousSelectedProfiles ? "Hide" : "Show"} all selected
                    </span>
                  </span>
                )}
              </div>
            </>
          )}
        {/* print static profiles till people are getting created */}
        {userData &&
          userData.id &&
          profilesData &&
          profilesData.length > 0 &&
          createPeopleFn.isLoading &&
          profilesData.map((profileEL) => {
            let profile = profileEL;
            profile.name = buildProfileName({
              first_name: profile?.first_name,
              last_name: profile?.last_name,
              full_name: profile?.full_name,
            });

            profile.current_company = {};
            profile.current_job_title = profile?.job_title;
            profile.current_company.name = profile?.company_name;
            return (
              <SingleContactCard
                profile={profile}
                userData={userData}
                activeWorkspace={activeWorkspace}
                profile_photo={profile?.person_profile_photo}
              />
            );
          })}

        {showPreviousSelectedProfiles && peopleFromIds.length > 0 && (
          <Button
            variant="danger-outline"
            className="w-full"
            onClick={() => {
              setShowPreviousSelectedProfiles(false);
              const filteredPeopleIds = peopleIds.filter((id) =>
                peopleFromIds.some((person) => person?.person_id === id)
              );

              // PostHog: Track clear selections
              captureEvent("EXP_BulkProfile_ClearSelections_Click", {
                cleared_count: filteredPeopleIds.length,
              });

              console.log("filteredPeopleIds", { filteredPeopleIds, peopleIds });
              removePeopleIds([...filteredPeopleIds]);
              removeContactIdsByKey("person_id", filteredPeopleIds);
              // clearProfiles();
            }}
          >
            <Trash2Icon className="h-4 w-4 mr-2" /> <span>Clear all previous selections</span>
          </Button>
        )}
        {userData &&
          userData.id &&
          profilesData &&
          profilesData.length > 0 &&
          !createPeopleFn.isLoading &&
          peopleFromIds &&
          peopleFromIds.length > 0 &&
          peopleFromIds.map((profile) => (
            <>
              {peopleIds.includes(profile?.id) &&
                !people.find((contact) => contact?.person?.id === profile?.id) && (
                  <div
                    className={`${!isThisProfileInCurrentEnrichedContacts(profile?.id) && !showPreviousSelectedProfiles ? "hidden" : "block"}`}
                  >
                    <SingleContactCard
                      key={profile?.id}
                      profile={{ ...profile, linkedin_url: profile?.linkedin_urls[0] }}
                      userData={userData}
                      activeWorkspace={activeWorkspace}
                      enriched={true}
                      profile_photo={getProfileObj(profile?.person_ids?.linkedin?.[0])?.person_profile_photo}
                      // contactIsRevealed={(contact) => {
                      //   updateRecords([{ contact: contact }]);
                      // }}
                      refetchContact={isBulkRevealed}
                      isBulkRevealing={revealContactFn.isLoading}
                      checkedItemId={peopleIds.find((el) => el === profile?.id)}
                      getCheckedItem={(person) => {
                        // toggleCheckbox({ id: person?.id });
                        // togglePeopleId(person?.id);
                        removePeopleIds([person?.person_id]);
                        removeContactIdsByKey("person_id", [person?.person_id]);
                      }}
                      cardType="delete"
                      crmObjectsConfig={crmObjectsConfig}
                      activeCrmId={activeCrmId}
                      crmSearchData={
                        profile?.contact_id
                          ? getCRMSearchRecordById(profile?.contact_id)?.records
                          : getCRMSearchRecordById(profile?.person_id)?.records
                      }
                      isCRMBulkSearchPending={
                        isCRMBulkSearchLoading &&
                        !getCRMSearchRecordById(profile?.contact_id) &&
                        !getCRMSearchRecordById(profile?.person_id)
                      }
                    />
                  </div>
                )}
            </>
          ))}
        {peopleIds && peopleIds.length > 0 && showPreviousSelectedProfiles && (
          <div className="py-1.5">
            <div className="h-[1px] border-b border-gray-300 -mx-3"></div>
          </div>
        )}
        {userData &&
          userData.id &&
          profilesData &&
          profilesData.length > 0 &&
          !createPeopleFn.isLoading &&
          people.length > 0 && (
            <div className={`flex justify-between`}>
              <span className="inline-flex items-center">
                <div className="inline-flex relative">
                  <input
                    checked={getCurrentPageCheckedProfiles().length === people?.length ? true : false}
                    onChange={(e) => {
                      const ids = people.map((item) => item?.person?.id && item?.person?.id);

                      if (e.target.checked) {
                        setPeopleIds((prev) => Array.from(new Set([...prev, ...ids])));
                      } else {
                        setPeopleIds((prev = []) =>
                          Array.isArray(ids) ? prev.filter((id) => !ids.includes(id)) : prev
                        );
                      }

                      // PostHog: Track select all action
                      captureEvent("EXP_BulkProfile_SelectAll", {
                        action: e.target.checked ? "select" : "deselect",
                        selected_count: e.target.checked ? ids.length : 0,
                        total_count: people?.length,
                      });
                    }}
                    type="checkbox"
                    className="mr-2 h-4 w-4 rounded border-gray-300 text-brand-700 focus:ring-brand-700 dark:text-brand-200 cursor-pointer"
                  />
                  {getCurrentPageCheckedProfiles().length > 0 &&
                    getCurrentPageCheckedProfiles().length < people?.length && (
                      <span className="custom_semi_checked">-</span>
                    )}
                </div>
                <span>{getCurrentPageCheckedProfiles().length} Selected</span>
              </span>
            </div>
          )}
        {userData &&
          userData.id &&
          profilesData &&
          profilesData.length > 0 &&
          !createPeopleFn.isLoading &&
          people &&
          people.length > 0 &&
          people.map(({ person: profile }) => (
            <div
              className={`${!isThisProfileInCurrentEnrichedContacts(profile?.id) && !showPreviousSelectedProfiles ? "hidden" : "block"}`}
            >
              <SingleContactCard
                key={profile?.id}
                profile={{ ...profile, linkedin_url: profile?.linkedin_urls[0] }}
                userData={userData}
                activeWorkspace={activeWorkspace}
                enriched={true}
                profile_photo={getProfileObj(profile?.person_ids?.linkedin?.[0])?.person_profile_photo}
                // contactIsRevealed={(contact) => {
                //   updateRecords([{ contact: contact }]);
                // }}
                refetchContact={isBulkRevealed}
                isBulkRevealing={revealContactFn.isLoading}
                checkedItemId={peopleIds.find((el) => el === profile?.id)}
                getCheckedItem={(person) => {
                  toggleCheckbox({ id: person?.person_id });
                  togglePeopleId(person?.person_id);
                }}
                crmObjectsConfig={crmObjectsConfig}
                activeCrmId={activeCrmId}
                crmSearchData={
                  profile?.contact_id
                    ? getCRMSearchRecordById(profile?.contact_id)?.records
                    : getCRMSearchRecordById(profile?.person_id)?.records
                }
                isCRMBulkSearchPending={
                  isCRMBulkSearchLoading &&
                  !getCRMSearchRecordById(profile?.contact_id) &&
                  !getCRMSearchRecordById(profile?.person_id)
                }
              />
            </div>
          ))}

        {/* profiles without companyname */}
        {userData &&
          userData.id &&
          !createPeopleFn.isLoading &&
          profilesDataWithoutCompanyName &&
          profilesDataWithoutCompanyName.length > 0 &&
          profilesDataWithoutCompanyName.map((profileEL) => {
            let profile = profileEL;

            profile.name = buildProfileName({
              first_name: profile?.first_name,
              last_name: profile?.last_name,
              full_name: profile?.full_name,
            });

            profile.current_company = {};
            profile.current_job_title = profile?.job_title;
            profile.current_company.name = profile?.company_name;
            return (
              <SingleContactCard
                profile={profile}
                userData={userData}
                activeWorkspace={activeWorkspace}
                noCompany={true}
                profile_photo={profile?.person_profile_photo}
              />
            );
          })}
      </div>
    </div>
  );
}
